import { useField } from "formik";
import { Dropdown } from "..";
import { checkFormValidity } from "../../../src/utils/helpers";

import React from "react";
import { WorkflowErrors } from "../../contexts/WorkflowErrors";

export default function (props) {
  const [field, meta, helper] = useField(props);
  const touchedError = meta.touched && meta.error;
  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);

  React.useEffect(() => {
    // function to check the validity of the field
    checkFormValidity(field, meta, props, taskErrors, setTaskErrors);
  }, [field, meta, props]);

  const propsObj = { ...props };
  delete propsObj.taskReferenceName;

  const handleChange = (e, value) => {
    if (props.onChange) {
      props.onChange();
    }
    helper.setValue(value);
  };

  return (
    <Dropdown
      {...propsObj}
      {...field}
      onChange={(e, value) => handleChange(e, value)}
      error={touchedError}
      helperText={touchedError}
    />
  );
}
